import { render, staticRenderFns } from "./SearchForCompany.vue?vue&type=template&id=562c4496&scoped=true"
import script from "./SearchForCompany.vue?vue&type=script&lang=js"
export * from "./SearchForCompany.vue?vue&type=script&lang=js"
import style0 from "./SearchForCompany.vue?vue&type=style&index=0&id=562c4496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c4496",
  null
  
)

export default component.exports